import React, { useState, useEffect } from 'react';
import StreamingSummaryTable from '../components/streaming/StreamingSummaryTable';
import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL + '/streaming';

export default function PGPStreamingPage() {
  const [audioOnly, setAudioOnly] = useState(false);
  const [totals, setTotals] = useState(null);
  const [maxDates, setMaxDates] = useState({ weekly_date: null, daily_date: null });

  useEffect(() => {
    const fetchTotals = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/streaming/totals_pgp`);
        setTotals(response.data);
      } catch (error) {
        console.error('Error fetching PGP totals:', error);
      }
    };

    const fetchMaxDates = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/streaming/max-dates`, {
          params: { is_pgp: true }
        });
        setMaxDates(response.data);
      } catch (error) {
        console.error('Error fetching max dates:', error);
      }
    };

    fetchTotals();
    fetchMaxDates();
  }, []);

  return (
    <div className="space-y-6">
      {totals && (
        <div className="bg-gray-50 p-4 sm:p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4">PGP Total Streams Last Week (Global)</h2>
          {maxDates.weekly_date && (
            <p className="text-sm text-gray-600 -mt-2 mb-2">Week Ending: {maxDates.weekly_date}</p>
          )}
          {/* {maxDates.daily_date && (
            <p className="text-sm text-gray-600 -mt-1 mb-4">Daily Ending: {maxDates.daily_date}</p>
          )} */}
          <div className="space-y-4">
            {/* Total Global Streams */}
            <div className="bg-white p-4 rounded-lg">
              <h4 className="text-sm font-medium text-gray-600 mb-2">Total Streams</h4>
              <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-4">
                <span className="text-xl sm:text-2xl font-bold">{totals.global_last_week.toLocaleString()}</span>
                <span className={`text-sm font-medium ${
                  parseFloat(totals.global_week_over_week_change) > 0 
                    ? 'text-green-600' 
                    : parseFloat(totals.global_week_over_week_change) < 0 
                    ? 'text-red-600' 
                    : 'text-gray-600'
                }`}>
                  {totals.global_week_over_week_change}
                </span>
              </div>
            </div>

            {/* Global Audio/Video Breakdown */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="bg-white p-3 rounded-lg">
                <h4 className="text-xs font-medium text-gray-600 mb-1">Audio Streams</h4>
                <div className="flex flex-col gap-1">
                  <span className="text-lg font-bold">{totals.global_audio_last_week.toLocaleString()}</span>
                  <span className={`text-xs font-medium ${
                    parseFloat(totals.global_audio_week_over_week_change) > 0 
                      ? 'text-green-600' 
                      : parseFloat(totals.global_audio_week_over_week_change) < 0 
                      ? 'text-red-600' 
                      : 'text-gray-600'
                  }`}>
                    {totals.global_audio_week_over_week_change}
                  </span>
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg">
                <h4 className="text-xs font-medium text-gray-600 mb-1">Video Streams</h4>
                <div className="flex flex-col gap-1">
                  <span className="text-lg font-bold">{totals.global_video_last_week.toLocaleString()}</span>
                  <span className={`text-xs font-medium ${
                    parseFloat(totals.global_video_week_over_week_change) > 0 
                      ? 'text-green-600' 
                      : parseFloat(totals.global_video_week_over_week_change) < 0 
                      ? 'text-red-600' 
                      : 'text-gray-600'
                  }`}>
                    {totals.global_video_week_over_week_change}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">PGP Streaming Data</h1>
          <div className="flex items-center gap-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={audioOnly}
                onChange={(e) => setAudioOnly(e.target.checked)}
                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-sm text-gray-700">Audio Only</span>
            </label>
          </div>
        </div>
        
        <StreamingSummaryTable
          type="song"
          audioOnly={audioOnly}
          group={null}  // No group filter for PGP
          isPgp={true}  // Filter for PGP songs
        />
      </div>
    </div>
  );
}